import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import MenuIcon from "@material-ui/icons/Menu";
import LogoPremium from "../../assets/images/logo.png";

import { createHashHistory } from "history";

import { NavLink } from "react-router-dom";

const useStyles = makeStyles({
	list: {
		width: 270,
	},
	fullList: {
		width: "auto",
	},
});

export const history = createHashHistory();

export default function TemporaryDrawer(props) {
	useEffect(() => {}, []);

	const classes = useStyles();
	const [state, setState] = useState({
		right: false,
	});

	const toggleDrawer = (side, open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}
		setState({ ...state, [side]: open });
	};

	const sideList = (side) => (
		<div
			className={classes.list}
			role="presentation"
			onClick={toggleDrawer(side, false)}
			onKeyDown={toggleDrawer(side, false)}
		>
			<List className="sidebar-drawer">
				<ListItem button>
					<NavLink className={"link-sidebar"} to={"/seja-um-parceiro"}>
						<ListItemIcon />
						<ListItemText primary={"Seja um parceiro"} />
					</NavLink>
				</ListItem>
				<ListItem button>
					<NavLink
						className={"link-sidebar"}
						to={"/central-de-noticias"}
					>
						<ListItemIcon />
						<ListItemText primary={"Central de Notícias"} />
					</NavLink>
				</ListItem>
			</List>
		</div>
	);

	const navList = () => (
		<List className="navbar-menu">
			<NavLink
				className="navbar-button"
				aria-controls="simple-menu"
				aria-haspopup="true"
				to={"/seja-um-parceiro"}
			>
				<span>Seja um parceiro</span>
			</NavLink>
			<NavLink
				className="navbar-button"
				aria-controls="simple-menu"
				aria-haspopup="true"
				to={"/central-de-noticias"}
			>
				<span>Notícias</span>
			</NavLink>
		</List>
	);

	return (
		<div className={"toolbar_parent"}>
			<div id={"toolbar_container"} className={"toolbar_container"}>
				<NavLink className={"toolbar_link"} to="/">
					<img
						className={"toolbar_img"}
						alt={"Logo-Premium"}
						src={LogoPremium}
					/>
				</NavLink>

				{navList()}

				<Button
					title={""}
					id={"sidebar_btn"}
					className={"sidebar-btn"}
					onClick={() => handleClick()}
				>
					<MenuIcon />
				</Button>
				<Drawer
					anchor="right"
					open={state.right}
					onClose={toggleDrawer("right", false)}
				>
					{sideList("right")}
				</Drawer>
			</div>
		</div>
	);

	function handleClick() {
		setState({ ...state, right: true });
	}
}
